import Loadable from '@townsquare/loadable';

export const ProjectsEmptyOrNonProvisionedState = Loadable({
  loader: () => import(/* webpackChunkName: "ProjectsEmptyOrNonProvisionedState" */ './EmptyOrNonProvisionedState'),
  loading: () => null,
});
